import { formatDistanceToNow, parseISO, subDays, differenceInDays } from "date-fns";
export const format4DigitTimeToAmOrPM = (time) => {
  const timeString = time.toString().padStart(4, "0");
  const hours24 = parseInt(timeString.slice(0, 2), 10);
  const minutes = timeString.slice(2);
  const period = hours24 >= 12 ? "PM" : "AM";
  const hours12 = hours24 % 12 || 12;
  return `${hours12.toString().padStart(2, "0")}:${minutes} ${period}`;
};

export function convertToK(price) {
  if (price >= 1000) {
    return (price / 1000).toFixed(1) + "K";
  } else {
    return price.toString();
  }
}

export function formatDateTimeToFullDatTime(input) {
  const date = new Date(input);
  const options = {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  const formattedDate = date.toLocaleString("en-US", options).replace(",", "");
  const [weekday, day, month, year, time] = formattedDate.split(" ");
  return `${weekday}, ${day} ${month}, ${year} : ${time}`;
}

export function formatDateToFullDate(dateInput) {
  const date = new Date(dateInput);
  const options = {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  };
  const formattedDate = date.toLocaleString("en-US", options).replace(",", "");
  const [weekday, day, month, year, time] = formattedDate.split(" ");
  return `${weekday}, ${day} ${month}, ${year}`;
}

export function getAgeFromGivenDate(birthDate) {
  const today = new Date();
  const birth = new Date(birthDate);

  let age = today.getFullYear() - birth.getFullYear();

  const monthDifference = today.getMonth() - birth.getMonth();
  const dayDifference = today.getDate() - birth.getDate();

  if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
    age--;
  }
  return age;
}

export function getYYYYmmddFromDate(date) {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

export function getRelativeTime(dateString) {
  const date = parseISO(dateString);
  const today = new Date();

  const daysDifference = differenceInDays(today, date);

  if (daysDifference === 0) {
    return "Today";
  } else if (daysDifference === 1) {
    return "Yesterday";
  } else if (daysDifference <= 7) {
    return `${daysDifference} days ago`;
  } else if (daysDifference <= 30) {
    const weeks = Math.floor(daysDifference / 7);
    return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
  } else if (daysDifference <= 365) {
    const months = Math.floor(daysDifference / 30);
    return `${months} month${months > 1 ? "s" : ""} ago`;
  } else {
    const years = Math.floor(daysDifference / 365);
    return `${years} year${years > 1 ? "s" : ""} ago`;
  }
}

export const getFulleDateTimeFromEpoch = (timestamp) => {
  const date = new Date(timestamp);
  const options = {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };
  const formattedDate = date.toLocaleString('en-US', options);
  return formattedDate;
}


export const getCurrentTimestamp = () => {
  const time = Date.now().toString();
  return time;
}

export const isDesktop = window.matchMedia("(min-width: 768px)").matches;
